import { render } from "./OurTeam.vue?vue&type=template&id=669f4595&scoped=true"
import script from "./OurTeam.vue?vue&type=script&lang=js"
export * from "./OurTeam.vue?vue&type=script&lang=js"

import "./OurTeam.vue?vue&type=style&index=0&id=669f4595&lang=scss"
import "./OurTeam.vue?vue&type=style&index=1&id=669f4595&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669f4595"]])

export default __exports__